import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SecurityComponent } from '../security/security.component';
import { Location } from '@angular/common';
import { YearwiseAppComponent } from 'src/app/yearwise-app/yearwise-app.component';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: '/board/dashboard',
    title: 'Dashboard',
    icon: 'ni-tv-2 text-primary',
    class: '',
  },
  {
    path: '/board/user-management',
    title: 'Users',
    icon: 'ni-single-02 text-yellow',
    class: '',
  },
  {
    path: '/board/permission',
    title: 'Permissions',
    icon: 'ni-tv-2 text-primary',
    class: '',
  },
  {
    path: '/board/admin',
    title: 'Admin Management',
    icon: 'ni-single-02 text-yellow',
    class: '',
  },
  // {
  //   path: '/board/masters',
  //   title: 'Master tables',
  //   icon: 'ni-circle-08 text-orange',
  //   class: '',
  // },
  {
    path: '/board/subscription',
    title: 'Subscription',
    icon: 'ni-badge text-red',
    class: '',
  },
  {
    path: '/board/subscription-report',
    title: 'Subscription Report',
    icon: 'ni-badge text-red',
    class: '',
  },
  {
    path: '/board/book-store',
    title: 'Book Store',
    icon: 'ni-books text-yellow',
    class: '',
  },
  {
    path: '/board/advertisement',
    title: 'Advertisement',
    icon: 'ni-chart-bar-32 text-orange',
    class: '',
  },
  // {
  //   path: '/board/representative',
  //   title: 'Representative',
  //   icon: 'ni-circle-08 text-orange',
  //   class: '',
  // },
  {
    path: '/board/book-seller',
    title: 'Issue/Granth Seller',
    icon: 'ni-paper-diploma text-red',
    class: '',
  },
  {
    path: '/board/accounts',
    title: 'Accounts',
    icon: 'ni-key-25 text-info',
    class: '',
  },
  //{ path: '/board/reports', title: 'Reports',  icon:'ni-chart-bar-32 text-pink', class: '' },
  // {
  //   path: '/board/invoice',
  //   title: 'Invoice',
  //   icon: 'ni-single-copy-04 text-orange',
  //   class: '',
  // },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public isCollapsed = true;
  user: any

  constructor(private router: Router, public dialog: MatDialog, private location: Location) { }

  ngOnInit() {
    // this.menuItems = ROUTES.filter((menuItem) => menuItem);

    const roleId = sessionStorage.getItem('role');
    this.user = sessionStorage.getItem("username");

    this.menuItems = ROUTES.filter((menuItem) => {
      // if (menuItem.title === 'Permissions' || menuItem.title === 'Users' || menuItem.title === 'Book Store') {
      if (menuItem.title === 'Permissions' || menuItem.title === 'Users') {
        return roleId === '1' || roleId === '2'; // Show only for role 1 & 2
      }
      return true; // Show other menus normally
    });

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  accountUserLoginVerification() {

  }

  logout() {
    sessionStorage.clear();
    localStorage.removeItem('rememberedUsername');
    localStorage.removeItem('rememberedPassword');
  }

  changeYear() {
    const dialogRef = this.dialog.open(YearwiseAppComponent, {
      disableClose: true,
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.selectedYear) {
        sessionStorage.setItem("selectedYear", result.selectedYear);
        sessionStorage.setItem("startDate", result.startDate);
        sessionStorage.setItem("endDate", result.endDate);
        this.router.navigate(['/board/dashboard']);
      }
      // Cancelled: leave the session untouched and stay on the current dashboard page.
    });
  }

  setTabIndex() {
    localStorage.setItem("tab", "0")
  }

  openRouterLink(menu) {
    debugger
    const storedPermissions = sessionStorage.getItem("permissions");
    let permissions: any[] = [];

    if (storedPermissions) {
      try {
        const parsed = JSON.parse(storedPermissions);
        permissions = parsed.permissions || []; // ✅ correctly take the array
      } catch (e) {
        console.error("Failed to parse permissions", e);
        permissions = [];
      }
    }

    console.log("Final permissions array:", permissions);

    // Now you can safely search
    // const accountsPermission = permissions.find((p: any) => p.menu_id == "1");

    // console.log(this.location.path())
    // if (menu.title != "Accounts") {
    //   this.router.navigate([menu.path])
    // }

    this.router.navigate([menu.path]);

    // if (menu.title == 'Accounts') {

    //   // Menu title is Accounts
    //   if (!accountsPermission || !accountsPermission.can_view) {
    //     // User does not have view permission
    //     alert("You do not have permission to access Accounts.");
    //     return;
    //   }

    //   if (this.location.path() == '/board/accounts') {
    //     return
    //   }
    //   const dialogdata = this.dialog.open(SecurityComponent, {
    //     data: {

    //     },
    //     width: '500px',
    //     height: '500px',
    //     maxWidth: '100%',
    //     disableClose: true
    //   });

    //   dialogdata.afterClosed().subscribe((result) => {
    //     if (result['data'] == 'success') {
    //       this.router.navigate([menu.path])
    //     }
    //   });
    // }
  }
}